import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { NoticeEdit } from '../model/noticeEdit';
import { merge } from 'lodash';
import { NoticeService } from 'src/app/core/service/notice.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import moment from 'moment';

@Component({
  selector: 'app-notice-edit',
  templateUrl: './notice-edit.component.html',
  styleUrls: ['./notice-edit.component.scss']
})
export class NoticeEditComponent
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<NoticeEdit> = new EventEmitter();

  public noticePriorities: Array<{ id: string; displayName: string; class: string }>;
  public editForm: any;
  public editFormActive = false;

  private noticeEdit: NoticeEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private messageHandlerService: MessageHandlerService,
    private noticeService: NoticeService)
  {
    this.noticePriorities = this.noticeService.noticePriorities;
  }

  public get text(): UntypedFormControl
  {
    return this.editForm.get('text');
  }

  public get priority(): UntypedFormControl
  {
    return this.editForm.get('priority');
  }

  public get startOn(): UntypedFormControl
  {
    return this.editForm.get('startOn');
  }

  public get endOn(): UntypedFormControl
  {
    return this.editForm.get('endOn');
  }

  @Input() public set model(notice: NoticeEdit)
  {
    this.initModel(notice);
  }

  public onSave(e: Event): void
  {
    e.preventDefault();

    if (this.startOn !== null && this.endOn !== null)
    {
      const d1 = moment(this.endOn.value);
      const d2 = moment(this.startOn.value);
      const diffMins = d1.diff(d2, 'minutes');
      if (diffMins <= 0)
      {
        this.messageHandlerService.displayError('DATE-RANGE-ERROR');
        return;
      }
    }

    const objectToPersist = merge(this.noticeEdit, this.editForm.value);

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(notice: NoticeEdit)
  {
    if (notice === undefined)
    {
      return;
    }

    // Set form
    this.editForm = this.fb.group({
      id: [null],
      text: [
        { value: '', disabled: false }, Validators.required
      ],
      active: { value: true, disabled: false },
      canDismiss: { value: true, disabled: false },
      priority: [{ value: '', disabled: false }, Validators.required],
      startOn: [{ value: null, disabled: false }, Validators.required],
      endOn: [{ value: null, disabled: false }, Validators.required]
    });

    notice.startOn = notice.startOn !== null ? new Date(notice.startOn) : null;
    notice.endOn = notice.endOn !== null ? new Date(notice.endOn) : null;

    this.editForm.reset(notice);
    this.noticeEdit = notice;
    this.editFormActive = notice !== undefined;
  }
}
